module.exports = __webpack_public_path__ + "static/media/Cowboy Bandit800_3c.855c2684.svg";